import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Link } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import { Modal } from 'react-bootstrap';
import OtpModal from '../Cart/OtpModal';
import { useHistory } from 'react-router-dom';
import FormGroup from '@mui/material/FormGroup';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { ConsentCheckboxesSignup } from '../../Components/ConsentCheckboxes';
import type { ConsentConfig } from '../../Components/ConsentCheckboxes';
import { CONSENT_KEYS } from '../../lib/constants';

type ConsentKey = typeof CONSENT_KEYS[number];

export default function LoginDetail(props: any) {
    const {
        email, setEmail, firstname, setFirstname,
        gender, setGender, date, setDate,
        password, setPassword, confirmPassword, setConfirmPassword,
        emailError, setEmailError, passwordError, setPasswordError,
        confirmPasswordError, setConfirmPasswordError, setDisableSignupBtn,
        isChecked, setIsChecked, setDisableGuestBtn, matchPasswordError, setMatchPasswordError,
        consentConfig = {}, consentValues = {}, setConsentValues,
    } = props

    const [firstError,setFirsterror]=useState(false)
    const { t } = useTranslation();


    const [show, setShow] = useState(false);
    const history = useHistory();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showPassword, setShowPassword] = useState(false);
    const [confirmshowPassword, setConfirmShowPassword] = useState(false);
    const lang = useCurrentLocale();

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleshowTogglePassword = () => {
        setConfirmShowPassword(!confirmshowPassword);
    };
    const dispatch = useDispatch();

    const handleCheckboxChange = (event: any) => {
        setIsChecked(event.target.checked);
    };

    const handleEmailChange = (e: any) => {
        const input = e.target.value;
        setEmail(e.target.value);

        // Email validation check
        const emailRegex = /^\S+@\S+\.\S+$/;
        setEmailError(!emailRegex.test(input));
        setDisableGuestBtn(false)
    };

    const handlePassword = (e: any) => {
        setPassword(e.target.value)
        if (e.target.value.length < 8) {
            setPasswordError(true)
        }
        else {
            setPasswordError(false)
        }
        if (confirmPassword != e.target.value) {
            setMatchPasswordError(true);
        }
        else {
            setMatchPasswordError(false)
        }
        if (confirmPassword) {
            if (confirmPassword != e.target.value) {
                setConfirmPasswordError(true);
            }
            else {
                setConfirmPasswordError(false)
            }
        }

        setDisableSignupBtn(false)
    }

    const handleConfirmPassword = (e: any) => {
        setConfirmPassword(e.target.value)
        if (password != e.target.value) {
            setConfirmPasswordError(true)
        }
        else {
            setConfirmPasswordError(false)
        }
        if (password != e.target.value) {
            setMatchPasswordError(true);
        }
        else {
            setMatchPasswordError(false)
        }


    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const hendleSingup = () => {
        history.push(`/${lang}/login`);

    }
    

    const handleEnterPress = (e: any) => {
        // if (e.key == "Enter" && firstname && lastname && email) { 
        //     handleSignup();
        // }
    }

    const handleFirstName = (e: any) => {
        const input = e.target.value;
        const regex = /^[a-zA-Z]*$/;

        if (regex.test(input)) {
            setFirstname(input);
        }
    }
    const handleLastName = (e: any) => {
        const input = e.target.value;
        const regex = /^[a-zA-Z]*$/;

        if (regex.test(input)) {
            setLastname(input);
        }
    }

    useEffect(()=>{
        if(!firstname){
            setFirsterror(true)
        }
        else{
            setFirsterror(false)
        }
    },[firstname])

    return (
        <div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="login-guest pb-0">
                        <div className="row">
                            <div className="col-md-12">
                                <div className='welcome-login font-normal '>
                                    <div className="col-md-12 mt-1">
                                        <TextField
                                            helperText={firstError ? t("FIRST_NAME_IS_REQUIRED") : ''}
                                            onKeyPress={handleEnterPress}
                                            value={firstname}
                                            onChange={handleFirstName}
                                            className='field-style color-white'
                                            id="filled-basic"
                                            label={<div className='font-normal d-flex gap-1'><p>{t("FULL_NAME")}</p><p className='color-theme h4'>*</p></div>}
                                            variant="filled"
                                            color="error"
                                        />
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <TextField onKeyPress={handleEnterPress} value={email} onChange={handleEmailChange}
                                            helperText={emailError ? t("EMAIL_IS_REQUIRED") : ''}
                                            className='field-style color-white' id="filled-basic" label={<div className='font-normal d-flex gap-1'><p>{t("EMAIL")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <TextField type='date'
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onChange={
                                                (e) => {
                                                    const selectedDate = e.target.value;
                                                    if (!selectedDate) {
                                                        setDate("");
                                                        return;
                                                    }
                                                    const currentDate = new Date().toISOString().split('T')[0];
                                                    if (selectedDate <= currentDate) {
                                                        setDate(e.target.value)
                                                    } else {
                                                        toast.error(t("FUTURE_DATE_ERROR"))
                                                        setDate("")
                                                    }
                                                }
                                            }
                                            className='field-style'
                                            value={date}
                                            onKeyPress={handleEnterPress}
                                            label={`${t("DOB")}`}
                                            variant="filled"
                                            name="dateofbirth" id="dateofbirth"
                                            color="error" />
                                        {/* <input value={date} onChange={(e)=>setDate(e.target.value)} className='date-burth w-100' type="date" name="dateofbirth" id="dateofbirth" /> */}
                                    </div>
                                    {setConsentValues && (
                                        <ConsentCheckboxesSignup
                                            config={consentConfig as ConsentConfig}
                                            values={consentValues as Partial<Record<ConsentKey, boolean>>}
                                            onChange={setConsentValues}
                                        />
                                    )}
                                       
                                    <FormControl>
                                        <h6 className='font-normal color-white mt-3 mb-0 h5'>{t("GENDER")} <span className='color-theme h4'>*</span></h6>
                                        <RadioGroup
                                            value={gender}
                                            onChange={(e) => setGender(e.target.value)}
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel className='color-white' value="Male" control={<Radio className='color-theme' />} label={t("MALE")} />
                                            <FormControlLabel className='color-white' value="Female" control={<Radio className='color-theme' />} label={t("FEMALE")} />
                                            <FormControlLabel className='color-white' value="Others" control={<Radio className='color-theme' />} label={t("OTHERS")} />
                                        </RadioGroup>
                                    </FormControl>
                                    {/* <div className="signup-login col-md-12 mt-3">
                                      <FormGroup>
                                          <FormControlLabel className='color-white signup-text' 
                                            control={<Checkbox
                                              checked={isChecked}
                                              onChange={handleCheckboxChange}
                                              inputProps={{ "aria-label": "controlled" }}
                                              className='color-theme' />} label="Sign up now to avail exclusive rewards & discounts" />
                                      </FormGroup>
                                  </div> */}
                                    {isChecked &&
                                        <div className="row">
                                            <div className="col-md-6 mt-3">
                                                {/* here */}
                                                <div className='position-relative'>
                                                    <TextField
                                                        value={password}
                                                        onChange={handlePassword}
                                                        helperText={passwordError ? t("PASSWORD_LENGTH_ERROR") : ''}

                                                        name="input2"
                                                        className='field-style' id="filled-basic" autoComplete="new-password" type={showPassword ? 'text' : 'password'} label={<div className='font-normal d-flex gap-1'><p>{t("PASSWORD")}</p><p className='color-theme h4'></p></div>} variant="filled" color="error" />
                                                    <Button onClick={handleTogglePassword} className='eye-btn' color="error"><i className={showPassword ? 'ri-eye-off-fill' : 'ri-eye-fill'}></i></Button>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <div className='position-relative'>
                                                    <TextField
                                                        value={confirmPassword}
                                                        onChange={handleConfirmPassword}
                                                        helperText={confirmPasswordError ? t("PASSWORD_MATCH_ERROR") : ''}
                                                        name="input2"
                                                        className='field-style' id="filled-basic" autoComplete="new-password" type={confirmshowPassword ? 'text' : 'password'} label={<div className='font-normal d-flex gap-1'><p>{t("CONFIRM_PASSWORD")}</p><p className='color-theme h4'></p></div>} variant="filled" color="error" />
                                                    <Button onClick={handleshowTogglePassword} className='eye-btn' color="error"><i className={confirmshowPassword ? 'ri-eye-off-fill' : 'ri-eye-fill'}></i></Button>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
